import { Action, Reducer } from 'redux';
import { AppThunkAction } from '../';
import * as SignIn from '../../models/signin/SignInAZAY';
import { debug } from 'console';

interface RequestFunctionAction {
    type: 'REQUEST_AZAY_SIGNIN';
}

interface ReceiveFunctionAction {
    type: 'RECEIVE_AZAY_SIGNIN';
    model?: SignIn.ResponseSignIn;
    message: any;
}

type KnownAction = RequestFunctionAction | ReceiveFunctionAction

export const actionCreators = {
    requestFunction: (username: string, password: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();

        if (appState) {
            var body = {
                'username': username,
                'password': password
            }
            //console.log(body)

            fetch(`/v1/citizen/azay/auth`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body)
            })
                .then(response => {
                    return response.json() as Promise<SignIn.ResponseSignIn>
                })
                .then(data => {
                    if (JSON.stringify(data.token) != undefined && JSON.stringify(data.token) != "" && JSON.stringify(data.token) != null) {
                        localStorage.setItem('SSO-WEB_APPLICATION', data.token);
                        dispatch({ type: 'RECEIVE_AZAY_SIGNIN', model: data, message: "" });
                    } else {
                        dispatch({ type: 'RECEIVE_AZAY_SIGNIN', model: data, message: "" });
                    }
                })
                .catch(error => {
                    dispatch({ type: 'RECEIVE_AZAY_SIGNIN', model: undefined, message: error });
                });

            dispatch({ type: 'REQUEST_AZAY_SIGNIN' });
        }

    }

};

const unloadedState: SignIn.SigninState = { isLoadingSignin: false, isLoginSuccess: false, responseSignin: undefined };

export const reducer: Reducer<SignIn.SigninState> = (state: SignIn.SigninState | undefined, incomingAction: Action): SignIn.SigninState => {
    if (state === undefined) {
        console.log('reducer state is undefined')
        return unloadedState;
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {

        case 'REQUEST_AZAY_SIGNIN':
            console.log('reducer RECEIVE_AZAY_SIGNIN')
            return {
                isLoadingSignin: true,
                isLoginSuccess: false
            };
        case 'RECEIVE_AZAY_SIGNIN':
            console.log('reducer RECEIVE_AZAY_SIGNIN', action.model)
            return {
                isLoadingSignin: false,
                isLoginSuccess: true,
                responseSignin: action.model,
                message: action.message
            };

        default: return state;
    }
};